import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconLinkedin: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        viewBox: '0 0 24 24',
        xmlns: 'http://www.w3.org/2000/svg',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.421 9.092H3.607a.306.306 0 0 0-.306.306v12.254c0 .17.137.306.306.306h3.814c.17 0 .307-.137.307-.306V9.398a.306.306 0 0 0-.307-.306ZM5.517 3A2.518 2.518 0 0 0 3 5.514 2.519 2.519 0 0 0 5.517 8.03a2.518 2.518 0 0 0 2.515-2.515A2.517 2.517 0 0 0 5.517 3ZM17.125 8.787c-1.532 0-2.665.659-3.351 1.407v-.796a.306.306 0 0 0-.307-.306H9.814a.306.306 0 0 0-.306.306v12.254c0 .17.137.306.306.306h3.806c.17 0 .307-.137.307-.306v-6.063c0-2.043.555-2.839 1.979-2.839 1.55 0 1.674 1.276 1.674 2.944v5.958c0 .17.137.306.306.306h3.808c.169 0 .306-.137.306-.306V14.93c0-3.037-.58-6.143-4.875-6.143Z',
    })
  )
}
